import { Box, Icon as ChakraIcon, Text } from '@chakra-ui/react';
import Link from 'next/link';

import Tooltip from '@/components/ui/Tooltip/Tooltip';

interface SidebarItemProps {
  href: string;
  isActive: boolean;
  Icon: React.ComponentType;
  label?: string;
  isExpanded?: boolean;
}

const SidebarItem = ({ href, isActive, Icon, label, isExpanded = false }: SidebarItemProps) => {
  const linkContent = (
    <Link id={`${href}-sidebar-item`} href={href}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        cursor="pointer"
        gap={3}
        py={3}
        pl={7}
        pr={isExpanded ? 4 : 7}
        width="100%"
        minWidth={0}
        maxWidth="100%"
        height="100%"
        borderRadius={8}
        backgroundColor={isActive ? 'purple.50' : 'transparent'}
        transition="background-color 0.2s ease-in-out"
        _hover={{
          backgroundColor: 'purple.50',
        }}
        overflow="hidden"
        boxSizing="border-box"
      >
        <ChakraIcon
          as={Icon}
          color={isActive ? 'purple.600' : 'purple.800'}
          width="24px"
          height="24px"
          flexShrink={0}
        />
        {label && (
          <Text
            fontSize="sm"
            fontWeight={500}
            color={isActive ? 'purple.600' : 'purple.800'}
            whiteSpace="nowrap"
            overflow="hidden"
            visibility={isExpanded ? 'visible' : 'hidden'}
            maxW={isExpanded ? 'none' : 0}
            opacity={1}
          >
            {label}
          </Text>
        )}
      </Box>
    </Link>
  );

  if (label && !isExpanded) {
    return (
      <Tooltip content={label} placement="right">
        {linkContent}
      </Tooltip>
    );
  }

  return linkContent;
};

export default SidebarItem;
